import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosNewApiInstance } from "../../services/api.js";

// ! Payments

// Get payment types +
export const getPaymentTypes = createAsyncThunk(
  "payments/getPaymentTypes",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(`/api/v1/payments/types`);
      console.log("getPaymentTypes", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create payment type +
export const createPaymentTypes = createAsyncThunk(
  "payments/createPaymentTypes",
  async (typeDetails, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/payments/types`,
        typeDetails
      );
      console.log("createPaymentTypes", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create income payment +
export const createPayment = createAsyncThunk(
  "payments/createPayment",
  async (paymentDetails, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/payments/`,
        paymentDetails
      );
      console.log("createPayment", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Patch income payment +
export const patchPayment = createAsyncThunk(
  "payments/patchPayment",
  async (paymentDetails, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.patch(
        `/api/v1/payments/${paymentDetails.id}/`,
        paymentDetails
      );
      console.log("patchPayment", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get Payment by Id (for Invoices page)+
export const getPaymentById = createAsyncThunk(
  "payments/getPaymentById",
  async (payment_id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/payments/${payment_id}`
      );
      console.log("getPaymentById", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get Payment Transfer By Id +
export const getCashTransferById = createAsyncThunk(
  "payments/getCashTransferById",
  async (transfer_id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/payment-transfers/${transfer_id}/`
      );
      console.log("getCashTransferById", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create cash transfer between two legal entities +
export const createCashTransfer = createAsyncThunk(
  "documents/createCashTransfer",
  async (cashTransferData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/payment-transfers/`,
        cashTransferData
      );
      console.log("createCashTransfer", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete payment +
export const deletePayment = createAsyncThunk(
  "payments/deletePayment",
  async ({ payment_id, delete_reason }, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/payments/${payment_id}/`,
        { data: { delete_reason } }
      );
      console.log("deletePayment", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);
